module.exports = __webpack_public_path__ + "media/images/version_merge/ssl_secure-35ad8cc8460e469285aa8bdee079b5ec.svg";